import React, {} from "react";
import { useDispatch } from "react-redux";
import { useToast } from "@chakra-ui/react";
import { MdSend as Ico } from 'react-icons/md';
// Components
import CommonButton from "../common/button/button";
// Actions
import * as pushNotificationsActions from "../../redux/actions/pushNotifications";
// Utils
import { getToastOpt } from "../../utils/utils";
import { TbRubberStamp } from "react-icons/tb";

const SendTestButton = ({ 
  id,
  setIsLoading,
  disabled,
}) => {
  const dispatch = useDispatch();
  const toast = useToast();

  let width = "120px";
  let marginLeft = "0px";

  return (
    <CommonButton
      onClick={() => {
        setIsLoading(true);
        dispatch(pushNotificationsActions.sendTest(id)).then(
          (response) => {
            setIsLoading(false);
            toast(getToastOpt({
              title: `Notificació de test enviada`,
              status: "success",
              position: "top",
            }));
          },
          (err) => {
            setIsLoading(false);
            toast(getToastOpt({
              title: `Error enviant notificació de test`,
              description: err,
              status: "error",
            }));
          }
        );
      }}
      style={{
        width,
        marginLeft,
        display: "flex", // Use flexbox to control alignment
        alignItems: "center", // Center icon and text vertically
        justifyContent: "flex-start", // Align icon and text to the left
        gap: "8px", // Add spacing between icon and text
      }}
      disabled={disabled}
      inverted={TbRubberStamp}
    >
      <Ico size={18} />
      <span>Test</span>
    </CommonButton>
  );
};

export default SendTestButton;
